module.exports = __webpack_public_path__ + "static/img/home2.28163c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home2.jpg
// module id = CDMO
// module chunks = 0